import PropTypes from "prop-types"
import React from "react"
import { OptionPropTypes } from "./../bag-prop-types"
import Option from "./Option"
import styled, { css } from "styled-components"
import { up } from "styled-breakpoints"

const Preview = styled.img`
width: 100%;
    object-fit: contain;
    margin: 10px 0;
    height: 140px;

    ${p => p.isSelected ? css`
    border: 2px solid var(--selected-color)
    
    ` : null}
`

const Figure = styled.figure`
  margin: 0;
  cursor: pointer;
  &:hover {
    cursor: pointer;
  }
`

const StyledOptionContainer = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(2,minmax(min-content, 42px));
  justify-content: center;
  margin-bottom:15px;
`
const StyledMeta = styled.div`
  display: flex;
  flex-direction: column;
font-style: normal;
font-weight: bold;
text-align:center;
line-height: 22px;
text-align: center;
font-family: 'Open Sans Condensed', sans-serif;
line-height: 1.7rem;

${up("md")}{
  line-height: 2.2rem;
}


strong{

  font-size: 1.2rem;
  opacity:0.5;

  ${up("md")}{
    font-size: 1.6rem;
}


}
small{
  font-size: 1.3rem;

  ${up("md")}{
    font-size: 1.7rem;


}

  
}

`

const Options = ({
  options,
  modelName,
  onImageClick,
  isSelected,
  dimensions,
  imgRootPath,
}) => {
  const [current, setCurrent] = React.useState(() => options[0])
  return (
    <Figure>
      <Preview
        isSelected={isSelected}
        alt={modelName}
        src={imgRootPath.concat(
          current.thumbnail ? current.thumbnail : current.src
        )}
        onClick={() => onImageClick(current)}
        loading="lazy"

      />
      <figcaption>
        <StyledOptionContainer>
          {options.map((option) => (
            <Option
              {...option}
              key={option.color}
              isSelected={isSelected && option.color === current.color}
              onOptionSelect={(payload) => {
                setCurrent(payload)
                onImageClick(payload)
              }}
            />
          ))}
        </StyledOptionContainer>
        <StyledMeta>
          <small>{dimensions}</small>
          <strong>{modelName}</strong>
        </StyledMeta>
      </figcaption>
    </Figure>
  )
}

Options.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape(OptionPropTypes)),
  modelName: PropTypes.string,
  onImageClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  dimensions: PropTypes.string,
  imgRootPath: PropTypes.string.isRequired,
}

export default React.memo(Options)
